<template>
  <div v-if="vehicle">
    <div
      v-if="vehicle.registration === null && vehicle.make === null && vehicle.model === null && vehicle.colour === null"
      class="mt-3"
    >
      <b>No vehicle details found</b>
    </div>
    <div class="row">
      <div
        v-if="vehicle.registration !== null"
        class="col-md-12 content-list mb-2"
      >
        <b>Registration:</b>
        <span v-if="!editModeValue">{{ vehicle.registration }}</span>
        <span>
          <input
            v-if="editModeValue"
            v-model="vehicleEdit.registration"
            :class="{ 'is-invalid': $v.vehicleEdit.registration.$invalid}"
            class="form-control mb-1"
          > &nbsp;
          <button
            v-if="editModeValue"
            :disabled="$v.vehicleEdit.registration.$invalid"
            class="btn btn-outline-secondary mb-1"
            @click="vehicleLookup"
          >
            Search
            <i class="icon--search" />
          </button>
        </span>
      </div>

      <div
        v-if="noVehicleFound"
        class="error"
      >
        Could not find vehicle
      </div>

      <div
        v-if="vehicle.make !== null"
        class="col-md-12 content-list mb-2"
      >
        <b>Make:</b>
        <span v-if="!editModeValue">{{ vehicle.make }}</span>
        <span>
          <input
            v-if="editModeValue"
            v-model="vehicleEdit.make"
            :class="{ 'is-invalid': $v.vehicleEdit.make.$invalid}"
            class="form-control"
          >
        </span>
      </div>
      <div
        v-if="vehicle.model !== null"
        class="col-md-12 content-list mb-2"
      >
        <b>Model:</b>
        <span v-if="!editModeValue">{{ vehicle.model }}</span>
        <span>
          <input
            v-if="editModeValue"
            v-model="vehicleEdit.model"
            :class="{ 'is-invalid': $v.vehicleEdit.model.$invalid}"
            class="form-control"
          >
        </span>
      </div>
      <div
        v-if="vehicle.colour !== null"
        class="col-md-12 content-list mb-2"
      >
        <b>Colour:</b>
        <span v-if="!editModeValue">{{ vehicle.colour }}</span>
        <span>
          <input
            v-if="editModeValue"
            v-model="vehicleEdit.colour"
            :class="{ 'is-invalid': $v.vehicleEdit.colour.$invalid}"
            class="form-control"
          >
        </span>
      </div>
    </div>

    <button
      v-if="editModeValue"
      class="btn btn-secondary mt-3"
      @click="editModeValue = !editModeValue"
    >
      Cancel
      <i class="icon--cross" />
    </button>
    <button
      v-if="editModeValue"
      :disabled="$v.$invalid && acceptInvalidDetails === false"
      class="btn btn-primary mt-3"
      @click="saveVehicle"
    >
      Save
      <i class="icon--floppy-disk" />
    </button>
  </div>
</template>

<script>
import {
    required,
    alphaNum,
    maxLength,
    helpers
} from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
const alphaNumericSpacesValidator = helpers.regex('custom', /^[a-zA-Z0-9 ]*$/)
export default {
    name: 'Vehicle',
    props: ['editMode'],
    data: function () {
        return {
            vehicleEdit: null,
            noVehicleFound: false,
            acceptInvalidDetails: false
        }
    },
    computed: {
        editModeValue: {
            get: function () {
                return this.editMode
            },
            set: function (newValue) {
                this.$emit('update:editMode', newValue)
            }
        },
        ...mapState({
            vehicle: state => state.booking.vehicle
        })
    },
    async created () {
        this.$store
            .dispatch('getVehicle', this.$route.params.bookingId)
            .then(response => {
                this.acceptInvalidDetails = true
            })
            .catch(response => {
                this.acceptInvalidDetails = false
            })

        this.vehicleEdit = Object.assign({}, this.$store.state.booking.vehicle)
    },
    validations: {
        vehicleEdit: {
            registration: {
                required,
                alphaNumericSpacesValidator,
                maxLength: maxLength(10)
            },
            make: {
                required,
                maxLength: maxLength(50)
            },
            model: {
                required,
                maxLength: maxLength(80)
            },
            colour: {
                required,
                maxLength: maxLength(20)
            }
        }
    },
    methods: {
        async saveVehicle () {
            const result = await this.$store.dispatch('updateVehicle', [
                this.$route.params.bookingId,
                this.vehicleEdit
            ])
            if (result.status === 200 || result.status === 201) {
                this.$toasted.success('Vehicle details saved')
                this.$store.dispatch('getAudit', this.$route.params.bookingId)
                this.editModeValue = false
                this.noVehicleFound = false
                await this.$store.dispatch('getVehicle', this.$route.params.bookingId)
            } else {
                this.$toasted.error(`Update Failed. ${result.data}`)
            }
        },
        async vehicleLookup () {
            await this.$store.dispatch('vehicleLookup', [
                this.vehicleEdit.registration,
                false
            ])

            if (this.$store.state.vehicle.vehicleLookup.registration !== null) {
                this.vehicleEdit = Object.assign(
                    {},
                    this.$store.state.vehicle.vehicleLookup
                )
                this.noVehicleFound = false
            } else {
                this.noVehicleFound = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
